import { NavItemType } from '../types/menu';
import i18n from '../i18n';
import { Category2, Driving, HomeTrendUp, Setting2 } from 'iconsax-react';

const icons = {
  dashboard: HomeTrendUp,
  roadmap: Driving,
  settings: Setting2,
  feeTypes: Category2,
};

const financeMenu: NavItemType = {
  id: 'finance',
  title: i18n.t('nav_section.finance'),
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: i18n.t('sidebar.dashboard'),
      type: 'item',
      url: '/dashboard',
      icon: icons.dashboard,
    },
    {
      id: 'settings',
      title: i18n.t('sidebar.school_settings'),
      type: 'item',
      url: '/settings',
      icon: icons.settings,
    },
    {
      id: 'feeManagement',
      title: i18n.t('fee_management.sidebar'),
      type: 'item',
      url: '/fee-management',
      icon: icons.feeTypes,
    },
  ],
};
export default financeMenu;
